import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { signInWithPopup } from "firebase/auth";
import React, { useState } from "react";
import Cookies from "universal-cookie";
import { auth, provider } from "../firebase-config.js";
import "../styles/Auth.css";
import "../styles/COLORS.css";

library.add(fas, fab);
const cookies = new Cookies();

export const Auth = (props) => {
  const { setIsAuth } = props;
  const [error, setError] = useState(null);

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      cookies.set("auth-token", result.user.refreshToken);
      setIsAuth(true);
    } catch (err) {
      setError(err.message);
      console.error(err);
    }
  };

  return (
    <body>
      <div className="auth" align="center">
        <div className="title">
          <h1>careChat</h1>
        </div>
        <div className="loginSection">
          <button onClick={signInWithGoogle} className="loginBtn">
            <p>
              <FontAwesomeIcon icon={["fab", "google"]} /> Mit Google anmelden
            </p>
            <p className="error">{error && <span>{error}</span>}</p>
          </button>
        </div>
        <div className="footer">
          <p>&copy; beqare.de</p>
        </div>
      </div>
    </body>
  );
};
